function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 10.2222V5.33333C13.3333 2.38781 10.9455 0 8.00001 0C5.05449 0 2.66668 2.38781 2.66668 5.33333V10.2222L0.444458 13.3333H15.5556L13.3333 10.2222ZM8.00001 16C8.98185 16 9.77779 15.2041 9.77779 14.2222H6.22224C6.22224 15.2041 7.01817 16 8.00001 16Z"
});
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    opacity: 0.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.fc40eb8f07b0a69f505ef1cf10518409.svg";
export { ForwardRef as ReactComponent };